"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _capitalize = _interopRequireDefault(require("../capitalize"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultOptions = {
  format: 'W',
  locale: 'es',
  capitalize: true
};

/**
 * Determines the week of the month for a given date.
 */
function getWeekOfMonth(date) {
  const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1).getDay();
  return Math.ceil((date.getDate() + firstDayOfMonth) / 7);
}

/**
 * Determines the week of the year for a given date.
 */
function getWeekOfYear(date) {
  const startOfYear = new Date(date.getFullYear(), 0, 1);
  const pastDays = Math.floor((date.getTime() - startOfYear.getTime()) / (1000 * 60 * 60 * 24));
  return Math.ceil((pastDays + startOfYear.getDay() + 1) / 7);
}

/**
 * Formats weeks based on the specified options.
 */
function getWeek(date) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    format,
    locale,
    capitalize: shouldCapitalize
  } = _objectSpread(_objectSpread({}, defaultOptions), options);
  const localeMap = {
    es: {
      W: 's',
      YW: 's',
      WWW: 'semana',
      YWWW: 'semana'
    },
    en: {
      W: 'w',
      YW: 'w',
      WWW: 'week',
      YWWW: 'week'
    }
  };
  let label = localeMap[locale][format];
  if (shouldCapitalize) {
    label = (0, _capitalize.default)(localeMap[locale][format]);
  }
  const weekOfMonth = getWeekOfMonth(date);
  const weekOfYear = getWeekOfYear(date);
  let week = '';
  switch (format) {
    case 'W':
      week = "".concat(label).concat(weekOfMonth);
      break;
    case 'WWW':
      week = "".concat(label, " ").concat(weekOfMonth);
      break;
    case 'YW':
      week = "".concat(label).concat(weekOfYear);
      break;
    case 'YWWW':
      week = "".concat(label, " ").concat(weekOfYear);
      break;
    default:
      throw new Error("Unsupported format: ".concat(format));
  }
  return shouldCapitalize ? (0, _capitalize.default)(week) : week;
}
var _default = exports.default = getWeek;